import React from 'react';
import {observer} from 'mobx-react';
import {OrbitSuspense} from '../base-components/orbit-suspense/orbit-suspense';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";

const CmsPageComponent = React.lazy(
  () => import("../cms-page/cms-page.component").then(({CmsPageComponent}) => ({default: CmsPageComponent}))
);

interface ArenaHostComponentProps extends ComponentServicesPick<'cmsPages'> {

}

const ComponentBody: React.FC<ArenaHostComponentProps> = observer((props) => {
  const services = useServices();
  if(props.cmsPages.currentPage) {
    return (<OrbitSuspense><CmsPageComponent/></OrbitSuspense>);
  } else {

    let arena = services.arenas.getCurrentArena();

    return arena?.renderArena() || null;
  }
});

export const ArenaHostComponent = withServices(ComponentBody, ['cmsPages']);
